import { CSS } from '@stitches/react';
import { ReactNode } from 'react';

export enum TooltipPosition {
  RIGHT = 'right',
  LEFT = 'left',
  TOP = 'top',
  BOTTOM = 'bottom',
}

export interface TooltipProps {
  children: ReactNode;
  containerClass?: string;
  position?: TooltipPosition;
  text: string;
  textStyles?: CSS;
}
